<template>
  
    <modal :show.sync="activarModal" >
      <b-card no-body class="overflow-hidden">
        <b-row no-gutters>
          <b-col md="6">
            <b-card-img
              :src="urlImage"
              alt="Image"
              class="rounded-0"
            ></b-card-img>
            <b-card-body :title="info.nombre + ' ' + info.apellido">
              <b-card-text>
                <b-list-group>
                  <b-list-group-item>
                    <b>Cedula</b>
                    <base-input
                      alternative
                      class="mb-3"
                      placeholder=""
                      addon-left-icon="ni ni-email-83"
                      v-model="info.cedula"
                    >
                    </base-input>
                  </b-list-group-item>
                  <b-list-group-item>
                    <b>Correo </b>
                    <base-input
                      alternative
                      class="mb-3"
                      placeholder=""
                      addon-left-icon="ni ni-email-83"
                      v-model="info.correo"
                    >
                    </base-input>
                  </b-list-group-item>
                  <b-list-group>
                    <b-list-group-item
                      ><b>Fecha de inscripción: </b>
                      <q-input></q-input>
                      {{ info.fecha_inscripcion }}
                    </b-list-group-item>
                  </b-list-group>
                  <b-list-group-item>
                    <b>Tipo de inscripción:</b> {{ info.tipo_inscripcion }}
                  </b-list-group-item>
                </b-list-group>
              </b-card-text>
            </b-card-body>
          </b-col>
          <b-col md="6">
            <b-card-text>
              <b-list-group>
                <b-list-group-item>
                  <b-form-select
                    v-model="status"
                    :options="options"
                    value-field="status_inscripcion"
                    text-field="status_inscripcion"
                  >
                  </b-form-select>
                  <!-- <b>Estado de inscripción:</b> {{ info.status_inscripcion }} -->
                </b-list-group-item>
                <b-list-group-item target="_blank" :href="urlCedula">
                  <b>Ver cédula</b>
                </b-list-group-item>
                <b-list-group-item>
                  <b-form-group label="">
                    <b-form-file
                      id="cedula"
                      size="sm"
                      @change="handleImage($event, 'cedula')"
                      accept="image/*"
                      placeholder="Nueva cédula..."
                      class="input-select"
                      required
                    ></b-form-file>
                  </b-form-group>
                </b-list-group-item>
                <b-list-group-item target="_blank" :href="urlAutPas">
                  <b>Ver Autorización Pastoral</b></b-list-group-item
                >
                <b-list-group-item>
                  <b-form-group label="">
                    <b-form-file
                      id="autorizacion_pastoral"
                      size="sm"
                      @change="handleImage($event, 'autorizacion_pastoral')"
                      accept="image/*"
                      placeholder="Nueva autori..."
                      class="input-select"
                      required
                    ></b-form-file>
                  </b-form-group>
                </b-list-group-item>

                <b-list-group-item target="_blank" :href="urlPlaIns"
                  ><b>Ver planilla de inscripción</b></b-list-group-item
                >
                <b-list-group-item>
                  <b-form-group label="">
                    <b-form-file
                      id="planilla"
                      size="sm"
                      @change="handleImage($event, 'planilla_ins')"
                      accept="image/*"
                      placeholder="Nueva planilla..."
                      class="input-select"
                      required
                    ></b-form-file>
                  </b-form-group>
                </b-list-group-item>

                <b-list-group-item target="_blank" :href="urlEstCur"
                  ><b>Ver certificado académico</b></b-list-group-item
                >
                <b-list-group-item>
                  <b-form-group label="">
                    <b-form-file
                      id="cedula"
                      size="sm"
                      @change="handleImage($event, 'autorizacion_pastoral')"
                      accept="image/*"
                      placeholder="Nueva autori..."
                      class="input-select"
                      required
                    ></b-form-file>
                  </b-form-group>
                </b-list-group-item>

                <b-list-group-item
                  v-if="urlEstCurEcl"
                  target="_blank"
                  :href="urlEstCurEcl"
                  ><b>Ver certificado eclesiasticos</b></b-list-group-item
                >

                <b-list-group-item v-else
                  ><b>No posee estudios eclesiasticos</b></b-list-group-item
                >
                <b-list-group-item>
                  <b-form-group label="">
                    <b-form-file
                      id="cedula"
                      size="sm"
                      @change="handleImage($event, 'autorizacion_pastoral')"
                      accept="image/*"
                      placeholder="Nueva autori..."
                      class="input-select"
                      required
                    ></b-form-file>
                  </b-form-group>
                </b-list-group-item>
              </b-list-group>
              <b-button @click="cambiarStatus" :disabled="comprobarEdicion"
                >Actualizar</b-button
              >
            </b-card-text>
            <span v-if="cambioForm != undefined" v-show="false">{{
              cambioForm.titulo
            }}</span>
          </b-col>
        </b-row>
      </b-card>
    </modal>

</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  name: "ModalInscripciones",
  components: {
    Modal,
  },
  props: ["inscripcion", "typeForm", "activarModal", "cambioForm"],
  data: function() {
    return {
      info: {},
      urlImage: "",
      urlAutPas: "",
      urlPlaIns: "",
      status: "",
      urlEstCur: "",
      urlEstCurEcl: null,
      urlCedula: "",
      options: ["Pendiente por aprobar", "Aprobado", "Por cancelar aranceles"],
    };
  },
  methods: {
    saveInformatcion() {
      this.$emit("listarInscripciones");
    },
  },
  computed: {
    cambioForm() {
      let inscripcion = this.inscripcion;

      if (this.typeForm === "Editar") {
        this.status = inscripcion.status_inscripcion;
        let baseUrl = process.env.VUE_APP_BASE_IMAGE;
        this.urlImage = baseUrl + inscripcion.foto;
        this.urlAutPas = baseUrl + inscripcion.autorizacion_pastoral;
        this.urlPlaIns = baseUrl + inscripcion.planilla_ins;
        this.urlEstCur = baseUrl + inscripcion.estudios_cursados;
        this.urlCedula = baseUrl + inscripcion.cedula_file;
        if (inscripcion.estudios_cursados_eclesiasticos) {
          this.urlEstCurEcl =
            baseUrl + inscripcion.estudios_cursados_eclesiasticos;
        }
        this.info = inscripcion;
        return { nombreBoton: "Actualizar", titulo: "Actualizar" };
      }
      if (this.typeForm === "Crear") {
        this.info = {};
        return { nombreBoton: "Registrar", titulo: "Registrar" };
      }
    },
    comprobarEdicion() {
      if (this.status != this.inscripcion.status_inscripcion) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async cambiarStatus() {
      var url = "inscriptions/updatestatus/" + this.inscripcion.id;
      const response = await this.$api({
        url: url,
        method: "POST",
        data: { status_inscripcion: this.status },
      });
      this.activarModal = false;
      console.log(response);
    },
    handleImage(e, type) {
      const image = e.target.files[0];
      this.validateFiles(image, type);
      this.createBase64Image(image, type).then((res) => {
        this.info[type] = res;
      });
    },
    createBase64Image(image, type) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>
